import API from './api';

export async function getDashboard(campaign) {
  const { data } = await API.get(`/campaigns/${campaign}/dashboard`);
  return data;
}